// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"9d4738ff","548":"ea3daf63","694":"cf6aa369"}[chunkId] + ".chunk.js";
};